import 'reflect-metadata'
import {inject, injectable} from 'inversify'
import {action, computed, makeObservable} from 'mobx'
import {
    PaymentMethodMerchantStoreModel,
    TPayByBankAppPaymentMethodStore
} from '@/pages/payment-methods'
import {PaymentMethodsActivateTerminalSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {
    AvailableStoresDataStore,
    AvailableStoresDataStoreSymbol
} from '@/stores/store-and-terminals'
import {
    ActivateTerminalStore,
    filterUnavailableTerminals,
    setTerminalsSwitchChangeOnStores
} from '@/stores/payment-methods'
import {PaymentMethodType} from '@/constants'

@injectable()
export class PayByBankAppPaymentMethodStore implements TPayByBankAppPaymentMethodStore {
    private _merchantStoresStore: AvailableStoresDataStore
    private _activateTerminalStore: ActivateTerminalStore

    constructor(
        @inject(AvailableStoresDataStoreSymbol) merchantStoresStore: AvailableStoresDataStore,
        @inject(PaymentMethodsActivateTerminalSymbol) activateTerminalStore: ActivateTerminalStore
    ) {
        this._merchantStoresStore = merchantStoresStore
        this._activateTerminalStore = activateTerminalStore

        makeObservable(this, {
            stores: computed,
            onTerminalSwitchChange: action.bound
        })
    }

    get stores(): PaymentMethodMerchantStoreModel[] {
        if (this._merchantStoresStore?.ecomStores === null) {
            return []
        }

        const filteredStores = filterUnavailableTerminals(
            this._merchantStoresStore.ecomStores,
            PaymentMethodType.paybybankapp
        )

        return setTerminalsSwitchChangeOnStores(filteredStores, this.onTerminalSwitchChange)
    }

    onTerminalSwitchChange = async (terminalId: string, checked: boolean) => {
        await this._activateTerminalStore.onTerminalSwitchChange(
            terminalId,
            checked,
            PaymentMethodType.paybybankapp
        )
    }
}
